import { render, staticRenderFns } from "./CardInnerLayout.vue?vue&type=template&id=5dba1152&scoped=true"
import script from "./CardInnerLayout.vue?vue&type=script&lang=ts"
export * from "./CardInnerLayout.vue?vue&type=script&lang=ts"
import style0 from "./CardInnerLayout.vue?vue&type=style&index=0&id=5dba1152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba1152",
  null
  
)

export default component.exports